module.exports = __webpack_public_path__ + "static/media/adjust.5c5c19cd.svg";